"use client";

import SchoolBrandingLayout from "@/app/(core)/(other)/pricing/SchoolBrandingLayout";
import PageSection, {
  PageSectionVariant,
} from "@/app/(core)/components/PageSection";
import SectionHeader from "@/app/(core)/components/SectionHeader";
import classes from "./trusted-by-schools-section.module.css";

interface TrustedBySchoolsSectionProps {
  title?: string;
  subTitle?: string;
  firstSection?: boolean;
  variant?: PageSectionVariant;
}

export default function TrustedBySchoolsSection({
  title,
  subTitle,
  firstSection,
  variant = "dark",
}: TrustedBySchoolsSectionProps) {
  return (
    <PageSection variant={variant} firstSection={firstSection}>
      <SectionHeader
        title={title ?? "Trusted By Schools Worldwide."}
        subTitle={subTitle ?? "500+ IB schools use Tiber Tutor. Join them."}
        align="center"
        needsLightTitle={variant === "dark"}
        isFirstSection={firstSection}
      />
      <div className={classes.schoolsWrap}>
        <SchoolBrandingLayout />
      </div>
    </PageSection>
  );
}
